import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { TooltipProps } from "recharts";

type ValueType = number | string | Array<number | string>;
type NameType = number | string;

type Props = TooltipProps<ValueType, NameType> & {
  formatter: (value: ValueType) => string;
};

const CustomTooltip: React.FC<Props> = ({
  active,
  payload,
  label,
  formatter,
}: Props): JSX.Element | null => {
  if (active && payload && payload.length) {
    return (
      <Box
        bg="white"
        p={2}
        border="1px solid #ccc"
        borderRadius="md"
        boxShadow="sm"
      >
        <Text fontWeight="bold" mb={2}>
          Día {label}
        </Text>
        {payload.map((entry, index) => {
          const value = entry.value;
          if (value != null) {
            const formattedValue = formatter(value);
            return (
              <Flex key={`item-${index}`} alignItems="center" mb={1}>
                <Box w={3} h={3} bg={entry.color} mr={2} />
                <Text>
                  {entry.name}: {formattedValue}
                </Text>
              </Flex>
            );
          }
          return null;
        })}
      </Box>
    );
  }

  return null;
};

export default CustomTooltip;
